import { DispatchLeg } from '@api/Trinium/Endpoints/Dispatch/types';
import { defaultSortComparator } from '@components/DataGrid/types';
import { applyColumnQuickFilter, caseInsensitiveIncludes } from '../columns';
import RenderHeader from '@components/DataGrid/RenderHeader';
import { HeaderSubLabel, SubColumnDef, subColumnField } from '@components/DataGrid/subColumns';
import RenderCell from '@components/DataGrid/RenderCell';
import { GridColDefExtended } from '@mui/x-data-grid-pro';

const traceEventField = 'Trc Event';

/** Sub-values of the Trc Event column sortable via hidden companion columns */
const traceEventSubColumns: SubColumnDef<DispatchLeg>[] = [
	{ key: 'location', label: 'Location', valueGetter: (row) => row.trcLocation },
	{ key: 'date', label: 'Trc Local Date', valueGetter: (row) => row.traceLocalDateTime?.unix }
];

const traceEventSubLabels: HeaderSubLabel[] = traceEventSubColumns.map((sub) => ({
	label: sub.label,
	field: subColumnField(traceEventField, sub.key)
}));

const traceEventDefinition: GridColDefExtended<DispatchLeg> = {
	field: traceEventField,
	minWidth: 130,
	width: 150,
	headerName: 'Trc Event|||Trc Location|||Trc Local Date/Time',
	subColumns: traceEventSubColumns,
	/** Mobile cards invoke renderHeader without params (RenderCardCell), so they fall back to the
	 * static secondaryText instead of mounting the grid-subscribing sort labels per card */
	renderHeader: (params) => (
		<RenderHeader
			primaryText='Trc Event'
			subLabels={params.field ? traceEventSubLabels : undefined}
			secondaryText='Location, Trc Local Date'
		/>
	),
	renderCell: ({ row }) => (
		<RenderCell
			primarySlot={<span title={row.trcEvent}>{row.trcEvent}</span>}
			secondarySlot={<span title={row.trcLocation}>{row.trcLocation}</span>}
			tertiarySlot={
				<span title={`${row.traceLocalDateTime?.date ?? ''} ${row.traceLocalDateTime?.time ?? ''}`}>
					{row.traceLocalDateTime?.shortDate}
				</span>
			}
		/>
	),
	disableReorder: true,
	getApplyQuickFilterFn: (value: string) => {
		return (_, row): boolean =>
			applyColumnQuickFilter(value, row, (value: string, row: DispatchLeg) => {
				const { trcEvent } = row;
				return caseInsensitiveIncludes(value, [trcEvent]);
			});
	},
	valueGetter: (_, row: DispatchLeg) =>
		`${row.trcEvent?.replaceAll(',', '') ?? ''}|||${row.trcLocation?.replaceAll(',', '') ?? ''}|||${row.traceLocalDateTime?.date ?? ''} ${
			row.traceLocalDateTime?.time ?? ''
		}`,
	sortable: true,
	sortComparator: (v1, v2, cellParams1) => {
		if (typeof v1 === 'string' && typeof v2 === 'string') {
			return defaultSortComparator(v1.split('|||')[0], v2.split('|||')[0], cellParams1);
		}

		return 0;
	}
};

export default traceEventDefinition;
